// Uploads are public files on the API origin, outside its /api route prefix.
export const resolveAssetUrl = (path, apiUrl = 'https://api.hooshpaz.ir/api') => {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    const url = new URL(path.startsWith('/') ? path : `/${path}`, new URL(apiUrl).origin);
    // Bypass CDN copies that cached the previous same-origin image policy.
    if (url.pathname.startsWith('/uploads/')) url.searchParams.set('v', '20260916');
    return url.href;
};
